module.exports = __webpack_public_path__ + "img/transport_paavirkning_biologiske.bdf1c9e5.jpg";